import { spawn } from "saga-query";

import {
  watchLxReportCalls,
  watchMenuOpenLocally,
  watchModelOperations,
} from "./ui/uiList";

// important running once per app session (not per login insider session)
export function* uiListReportsSaga() {
  yield* spawn(watchLxReportCalls);
  yield* spawn(watchMenuOpenLocally);
  yield* spawn(watchModelOperations);
}
